import {CreateResourceKeyPayload, MediaProps, UpdatedMediaProps} from "./types";
import {DEFAULT_MEDIA_PROPERTIES} from "../../utils/constants";

/**
 * Sign resource key is <fileReference>_<signType>.
 *
 * @param {string} fileReference
 * @param {SignTokenType} signType
 * @retuen {string}
 */
export const createSignedResourceKey = ({
    fileReference, signType,
}: CreateResourceKeyPayload): string => `${fileReference}_${signType}`;

/**
 * Update custom tag props
 *
 * @param {MediaProps} mediaProps
 * @return {UpdatedMediaProps}
 */
export const updateResourceProps = (mediaProps: MediaProps): UpdatedMediaProps => {
    const updatedProps: MediaProps = {...DEFAULT_MEDIA_PROPERTIES, ...mediaProps};
    const {
        children, src, signType, alt, isLegacySign,
    }: MediaProps = updatedProps;
    delete updatedProps.children;
    delete updatedProps.node;
    delete updatedProps.src;
    delete updatedProps.signType;
    delete updatedProps.signResource;
    delete updatedProps.isLegacySign;
    delete updatedProps.onerror;

    return {
        src,
        signType,
        updatedProps,
        alt,
        children,
        isLegacySign,
    };
};
